import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

export const loginsSlice = createSlice({
  name: 'logins',
  initialState: initialState,
  reducers: {
    clearLogins: () => {
      return initialState;
    },

    pushLogin: (state, action) => {
      return [action.payload, ...state];
    },

    popLogin: (state) => {
      return state.length > 0 ? state.slice(1) : state;
    },
  },
});

export const { clearLogins, pushLogin, popLogin } = loginsSlice.actions;

export default loginsSlice.reducer;
